module.exports = __webpack_public_path__ + "img/arch-inf.36268965.svg";